import { Component, Input } from '@angular/core';

@Component({
  selector: 'mprd-create-mailbox-button',
  templateUrl: 'create-mailbox-button.component.html',
})
export class CreateMailboxButtonComponent {
  @Input() displayOnMobileSize: any;
}
